const dc = require("bundle-text:./dc-offset.js.raw");
const scope = require("bundle-text:./scope.js.raw");

export default [dc, scope].map((jsString) => {
  return URL.createObjectURL(new Blob([jsString], { type: "application/javascript" }))
});
